export default "__VITE_ASSET__Ce0akKj$__"